import * as S from './styles'
import {useRef} from "react";

export const Content6 = () => {

    const videoRef = useRef<HTMLVideoElement>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);

    const canvas = canvasRef.current;
    if (canvas) {
        const ctx = canvas?.getContext("2d") as CanvasRenderingContext2D;

        const w = canvas.clientWidth || 0;
        const h = canvas.clientHeight || 0;

        canvas.width = w;
        canvas.height = h;

        const video = videoRef.current;
        if (video) {
            ctx.drawImage(video, 0, 0, w, h);
        }
    }

    return (
        <S.Container>
            <S.Title>
                TeleGuard для бизнеса: безопасный мессенджер для вашего бизнеса
                Доступно в ближайшее время
            </S.Title>
            <S.Video ref={videoRef} controls webkit-playsinline playsInline loop muted>
                <source src="https://teleguard.com/video/Vorverkauf_TeleGuard.mp4"/>
            </S.Video>
            {/*<S.Canvas ref={canvasRef}/>*/}
        </S.Container>
    )
}